// Census-based ZIP code to county mapping service
import zipCountyMapping from '../data/zipCountyMapping.json';

export const censusCountyService = {
  
  /**
   * Get county name for a ZIP code using Census data
   * @param {string} zipCode - 5-digit ZIP code
   * @returns {string|null} - County name or null if not found
   */
  getCountyForZipCode: (zipCode) => {
    if (!zipCode || typeof zipCode !== 'string') {
      return null;
    }
    
    // Ensure 5-digit ZIP code
    const cleanZip = zipCode.trim().slice(0, 5);
    
    if (!/^\d{5}$/.test(cleanZip)) {
      return null;
    }
    
    return zipCountyMapping[cleanZip] || null;
  },
  
  /**
   * Check if a ZIP code exists in Census data
   * @param {string} zipCode - 5-digit ZIP code
   * @returns {boolean} - True if ZIP code exists in mapping
   */
  hasZipCode: (zipCode) => {
    if (!zipCode || typeof zipCode !== 'string') {
      return false;
    }
    
    const cleanZip = zipCode.trim().slice(0, 5);
    return zipCountyMapping.hasOwnProperty(cleanZip);
  },
  
  /**
   * Get statistics about the Census mapping data
   * @returns {Object} - Statistics about the mapping
   */
  getStats: () => {
    const totalZipCodes = Object.keys(zipCountyMapping).length;
    const uniqueCounties = new Set(Object.values(zipCountyMapping)).size;
    
    return {
      totalZipCodes,
      uniqueCounties,
      sampleMapping: Object.entries(zipCountyMapping).slice(0, 5).reduce((acc, [zip, county]) => {
        acc[zip] = county;
        return acc;
      }, {})
    };
  },
  
  /**
   * Batch lookup counties for multiple ZIP codes
   * @param {string[]} zipCodes - Array of ZIP codes
   * @returns {Object} - Object mapping ZIP codes to county names
   */
  batchGetCounties: (zipCodes) => {
    const results = {};
    
    for (const zipCode of zipCodes) {
      const county = censusCountyService.getCountyForZipCode(zipCode);
      if (county) {
        results[zipCode] = county;
      }
    }
    
    return results;
  }
};

export default censusCountyService;